import * as React from "react";

import { cn } from "../../lib/utils";

type TextareaProps = React.ComponentProps<"textarea"> & {
  size?: "xs" | "sm" | "default" | "lg";
  visualSize?: "default" | "tall";
};

function Textarea({
  className,
  size = "default",
  visualSize = "default",
  ...props
}: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex w-full rounded-lg border border-input bg-transparent px-2.5 py-2 text-nav leading-nav text-foreground outline-none placeholder:text-muted-foreground focus:border-ring focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50",
        visualSize === "tall" ? "min-h-28" : "min-h-16",
        size === "xs" && "min-h-12 px-2 py-1.5 text-xs leading-xs",
        size === "sm" && "min-h-14 px-2.5 py-2 text-nav leading-nav",
        size === "lg" && "min-h-20 px-3 py-2.5 text-sm leading-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
